import { Group } from '@components/layout';
import { Typography } from '@components/typography';
import { Stack, SxProps } from '@mui/material';
import { PropsWithChildren, ReactNode } from 'react';

export type PageHeaderProps = PropsWithChildren<{
  title?: ReactNode;
  description?: string;
  sx?: SxProps;
}>;

export const PageHeader = ({ children, sx, title, description }: PageHeaderProps) => (
  <Stack mb={5} sx={{ transition: 'all 0.3s ease-in-out', ...sx }}>
    <Group
      className="page-header-title-group"
      sx={{
        justifyContent: 'space-between',
        alignItems: 'flex-start',
      }}
    >
      {title && (
        <Typography
          maxWidth="400px"
          variant="h2"
          sx={{ fontWeight: '400' }}
          noWrap
          handleOverFlow
          color="text.accent"
        >
          {title}
        </Typography>
      )}
      {children}
    </Group>
    {description && (
      <Typography
        variant="body2"
        color="foreground.default.light"
        sx={{ mt: 1 }}
        className="page-header-description"
      >
        {description}
      </Typography>
    )}
  </Stack>
);
